/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Body for ``POST .../linkedin/checkpoint/resend`` — ask Unipile to
 * re-issue the pending checkpoint for the in-flight intent.
 */
export interface LinkedInCheckpointResendRequest {
  linkedin_account_id: string;
}
